import { render } from "./MySidenavList.vue?vue&type=template&id=7da2f4b6&scoped=true"
import script from "./MySidenavList.vue?vue&type=script&lang=js"
export * from "./MySidenavList.vue?vue&type=script&lang=js"

import "./MySidenavList.vue?vue&type=style&index=0&id=7da2f4b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7da2f4b6"]])

export default __exports__